import { Injectable } from '@angular/core';
import { NbComponentOrCustomStatus, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { NbToastrConfig } from '@nebular/theme/components/toastr/toastr-config';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ToastrService {

  readonly defaultLoadingErrorMessage = 'LOADING.ERROR.MESSAGE';

  constructor(
    private toastrService: NbToastrService,
    private translate: TranslateService,
  ) {
  }

  public showCreationErrorToast(message = 'FORM.ERROR.MESSAGE', title = 'FORM.ERROR.TITLE') {
    this.showCreationToast(message, title, 'danger', 10000);
  }

  public showCreationSuccessToast(message: string, title = 'FORM.SUCCESS.TITLE') {
    this.showCreationToast(message, title, 'success');
  }

  public showDeleteCreationSuccess(message = 'DELETE.SUCCESS.MESSAGE', title = 'DELETE.SUCCESS.TITLE') {
    const config: Partial<NbToastrConfig> = {
      status: 'success',
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.displayToast(message, title, config);
  }

  public showInfoToast(message: string, title = 'INFO.TITLE') {
    const config: Partial<NbToastrConfig> = {
      status: 'info',
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.displayToast(message, title, config);
  }

  public showLoadingErrorToast(message = this.defaultLoadingErrorMessage, title = 'LOADING.ERROR.TITLE') {
    const config: Partial<NbToastrConfig> = {
      status: 'danger',
      destroyByClick: true,
      duration: 5000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    if (message.length <= 0) {
      message = this.defaultLoadingErrorMessage;
    }

    this.displayToast(message, title, config);
  }

  /**
   * Toaster to use only to display server errors.
   * This function MUST ONLY BE USED in some API services.
   *
   * @param message
   * @param title
   */
  public showServerErrorToast(message, title) {
    message = message || 'Unidentified troubles have occurred ! Please contact a developer now.';
    title = title || 'Server error';

    this.toastrService.show(
      message,
      title,
      {
        status: 'danger',
        destroyByClick: true,
        duration: 10000,
        hasIcon: true,
        position: NbGlobalPhysicalPosition.TOP_RIGHT,
        preventDuplicates: true,
      },
    );
  }

  public showWarningToast(message: string, title = 'INFO.TITLE') {
    const config: Partial<NbToastrConfig> = {
      status: 'warning',
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.displayToast(message, title, config);
  }

  private displayToast(message: string, title: string, config: Partial<NbToastrConfig>) {
    this.toastrService.show(
      this.translate.instant(message),
      this.translate.instant(title),
      config,
    );
  }

  private showCreationToast(message: string, title: string, status: NbComponentOrCustomStatus, duration = 5000) {
    const config: Partial<NbToastrConfig> = {
      status,
      destroyByClick: true,
      duration,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.displayToast(message, title, config);
  }
}
